// extracted by mini-css-extract-plugin
module.exports = {"buttons":"CartModals_buttons__8c3fW","orderOverviewModal":"CartModals_orderOverviewModal__1KtTe"};